interface Rules {
  [key: string]: (...value: any) => true | string | ((...value: any) => true | string)
}

export default class Validations {
  public static rules: Rules = {
    required: (value: string | boolean) => {
      if (typeof value === 'boolean') {
        return true
      }
      return !!value || 'required'
    },
    email: (value: string) => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(value) || 'invalid email'
    },
    phone: (value: string) => {
      const pattern = /^\+[0-9]{10,15}$/
      return pattern.test(value) || 'invalid phone'
    },
    number: (value: string) => {
      const pattern = /^[0-9]*$/
      return pattern.test(value) || 'only numbers are allowed'
    },
    boolean: (value: string | boolean) => {
      value = !!value
      return typeof value === 'boolean' || 'input must be a boolean'
    },
    nullable: () => {
      return true
    },
    digitsBetween: (min: string | number, max: string | number) => {
      return (value: number | string) => {
        const v = value.toString()
        return v.length >= min && v.length <= max || `must be a number between ${min} and ${max} digits`
      }
    },
  }
}
